/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Paper, Typography } from '@mui/material'

import EnvelopFilterPanel from '@components/enevelopFilterPanel/EnevelopFilterPanel'
import EnevelopStatus from '@components/enevelopStatus/EnevelopStatus'
import EnvelopActionPanel from '@components/enevelopActionPanel'
import { getEnvelops } from '@store/slices/Dashboard.slice'
import useScedular from '@hooks/useScedular.hook'
import { type RootState } from '@store/index'

import { DASHBOARD_REFRESH_TIME } from '@config/Constants'
import EmtyMailBoxSVG from '@assets/images/EmtyMailBox.svg'
import LoaderGif from '@assets/images/spinner-verified.gif'
import styles from './Dashboard.styles'

const DashboardPage: React.FC = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const envelopsData = useSelector((state: RootState) => state.dashboard.filteredEnevelopData)
    const envelopsLoading = useSelector((state: RootState) => state.dashboard.envelopsLoading)

    const handleGetEnvelop = (): void => {
        dispatch(getEnvelops())
    }
    useScedular(handleGetEnvelop, DASHBOARD_REFRESH_TIME)

    return (
        <div>
            <Grid sx={styles.filterWrapper}>
                <EnvelopFilterPanel />
            </Grid>
            <Grid sx={styles.contentContainer}>
                <Grid sx={styles.contentWrapper}>
                    <Grid container alignItems="center" flexDirection="column">
                        {envelopsData?.envelops.map((item, index) => (
                            <Paper sx={styles.paper} key={index}>
                                <div style={styles.leftWrapper}>
                                    <Typography variant="body1" color="primary" sx={styles.mainLabel}>
                                        {t(`greeting.standard.part1`)}&nbsp;
                                        {t(`greeting.standard.part2`)}&nbsp;
                                        {item.state.sender.email}&nbsp;
                                        {t(`greeting.standard.part3`)}&nbsp;
                                    </Typography>
                                    <EnevelopStatus
                                        state={item.state}
                                        isAborted={item.isAborted}
                                        isCompleted={item.isCompleted}
                                        isRejected={item.isRejected}
                                        publishDate={item.publishDate}
                                        id={item.envelopeId}
                                    />
                                </div>
                                <EnvelopActionPanel
                                    isCompleted={item.isCompleted}
                                    showActionLink={item.showActionLink}
                                    actionLink={item.actionLink}
                                    state={item.state}
                                />
                            </Paper>
                        ))}

                        {envelopsData?.count === 0 && (
                            <div style={styles.emtyBox}>
                                <div>
                                    <img src={EmtyMailBoxSVG} />
                                </div>
                                <div>{t('review.no_envelopes_found')}</div>
                            </div>
                        )}
                        {envelopsLoading && envelopsData?.count === 0 && <img src={LoaderGif} />}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default DashboardPage
